import { CardBadge } from "@/components/shared/card-badge";

type CampaignPlacementBadgesProps = {
  placements: string[];
  maxVisible?: number;
};

export function CampaignPlacementBadges({
  placements,
  maxVisible,
}: CampaignPlacementBadgesProps) {
  const visiblePlacements =
    maxVisible === undefined ? placements : placements.slice(0, maxVisible);
  const hasHiddenPlacements =
    maxVisible !== undefined && placements.length > maxVisible;

  return (
    <div className="tw:flex tw:flex-wrap tw:gap-2">
      {visiblePlacements.map((placement, index) => (
        <CardBadge key={`${placement}-${index}`} variant="outline">
          {placement}
        </CardBadge>
      ))}
      {hasHiddenPlacements && <CardBadge variant="outline">...</CardBadge>}
    </div>
  );
}
